import request from '@/libs/request'
import { toast } from '../libs/utils'

// 获取匹配影像列表
export async function getMateImageList (params) {
  let data = await request.post('/order/orderCheckImageInfo/findPage', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '获取匹配影像列表异常' })
  }
}
// 匹配影像
export async function mateImage (params) {
  let data = await request.post('/order/orderCheckImageInfo/mateImage', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return true
  } else {
    toast({ msg: data.message || '匹配影像异常' })
  }
}
// 解绑影像
export async function removeImage (params) {
  let data = await request.post('/order/orderCheckImageInfo/removeImage', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return true
  } else {
    toast({ msg: data.message || '解绑影像异常' })
  }
}
// 获取报告单信息
export async function getReportInfo (params) {
  let data = await request.post('/order/orderCheckReport/getRoutineReport', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '查询异常' })
  }
}
// 查询影像操作记录
export async function getImagesRecord (params) {
  let data = await request.post('/order/orderCheckImageOperationLog/listBLOBsByOrderCheckId', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '查询异常' })
  }
}
